<template>
  <article class="feature-card">
    <!-- Star circle  -->
    <div class="feature-card__star">
      <i class="feature-star__icon" :class="icon"></i>
    </div>
    <!-- Title  -->
    <h1 class="feature-card__title">
      {{ title }}
    </h1>
    <!-- Description  -->
    <p class="feature-card__description --text-is-gray">
      {{ text }}
    </p>
  </article>
</template>

<script>
export default {
  name: 'FeatureCard',
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
</style>
